module.exports = __webpack_public_path__ + "media/img/Landing_Page/online_feedback-67403e1389024f1c3f3342a8720fa2e1.jpg";